import { action } from "satcheljs";
import type { ClientItemId } from "owa-client-ids";

export interface OnMailServiceReplyReplyAllMessageActionMessage {
    clientItemId: ClientItemId;
    isReplyAll: boolean;
}
const onMailServiceReplyReplyAllMessage: (clientItemId: ClientItemId, isReplyAll: boolean) => OnMailServiceReplyReplyAllMessageActionMessage = action("onMailServiceReplyReplyAllMessage", (clientItemId: ClientItemId, isReplyAll: boolean): OnMailServiceReplyReplyAllMessageActionMessage => ({
    clientItemId,
    isReplyAll,
}));

export default onMailServiceReplyReplyAllMessage;
